import {
  BriefcaseBusiness,
  Landmark,
  ShieldUser,
  UserRound,
  UserRoundPen,
  Users,
  UserStar,
  type LucideIcon,
} from 'lucide-react';
import { APP_ROLE, COMPANY_ROLE, TEAM_ROLE } from '@/models/references/references';

/** Picto de chaque rôle, partout où un rôle est affiché (listes, fiches, organigramme) ; par la reference de l'enum */
const ROLE_ICONS: Record<string, LucideIcon> = {
  [COMPANY_ROLE.DIRECTOR]: BriefcaseBusiness,
  [COMPANY_ROLE.ASSISTANT]: UserRoundPen,
  [COMPANY_ROLE.EMPLOYEE]: UserRound,
};

const TEAM_ROLE_ICONS: Record<string, LucideIcon> = {
  [TEAM_ROLE.MANAGER]: UserStar,
  [TEAM_ROLE.TEAMMATE]: UserRound,
};

const APP_ROLE_ICONS: Record<string, LucideIcon> = {
  [APP_ROLE.ADMIN]: ShieldUser,
  [APP_ROLE.USER]: UserRound,
};

/** Rôle dans la société (Dirigeant, Assistant, Employé) */
export const companyRoleIcon = (reference: string): LucideIcon => ROLE_ICONS[reference] ?? UserRound;

/** Rôle dans l'équipe (Manager, Équipier) */
export const teamRoleIcon = (reference: string): LucideIcon => TEAM_ROLE_ICONS[reference] ?? UserRound;

/** Rôle dans l'application (Administrateur, Utilisateur) */
export const appRoleIcon = (reference: string): LucideIcon => APP_ROLE_ICONS[reference] ?? UserRound;

/** Groupes de l'organigramme : direction (Dirigeants et Assistants), manager, équipiers */
export const ORG_GROUP_ICONS = { direction: Landmark, manager: UserStar, teammates: Users } as const;
